import { useTranslations } from '@vocab/react';
import { Box, Button, Heading, Inline, Stack, Text } from 'braid-design-system';

import { AiLogoSvg } from 'src/app/v1/views/components/OptimisationSuggestions/AiLogoSvg';
import { SeekAiSectionDivider } from 'src/app/v1/views/pages/Write/sections/SeekAiSection/components/SeekAiSectionDivider';

import translations from './.vocab';

import * as styles from 'src/app/v1/views/components/OptimisationSuggestions/index.css';

interface AIContentGenerateButtonProps {
  buttonText: string;
  onGenerateClick: () => void;
}

const AIContentGenerateButton = ({
  buttonText,
  onGenerateClick,
}: AIContentGenerateButtonProps) => (
  <Box
    component="button"
    className={styles.applyButton}
    borderRadius="standard"
    onClick={onGenerateClick}
    background="customDark"
    padding="small"
  >
    <Text size="small" weight="medium">
      {buttonText}
    </Text>
  </Box>
);

interface SeekAiSectionProps {
  shouldRenderGenerateAdSection: boolean;
  hasEnoughWordsToSuggest: boolean;
  onGenerateSuggestions: () => void;
  onGenerateDescription: () => void;
}

export const SeekAiSection = ({
  shouldRenderGenerateAdSection,
  hasEnoughWordsToSuggest,
  onGenerateSuggestions,
  onGenerateDescription,
}: SeekAiSectionProps) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="small">
      <AiLogoSvg />
      <Stack space="large">
        <Stack space="medium">
          <Heading level="4">{t('seek-ai-suggestions-heading')}</Heading>
          {hasEnoughWordsToSuggest ? (
            <>
              <Text size="small">{t('seek-ai-suggestions-description')}</Text>
              <Inline space="none">
                <AIContentGenerateButton
                  buttonText={t('seek-ai-suggest-cta')}
                  onGenerateClick={onGenerateSuggestions}
                />
              </Inline>
            </>
          ) : (
            <Text size="small">
              {t('seek-ai-suggestions-insufficent-content')}
            </Text>
          )}
        </Stack>
        {shouldRenderGenerateAdSection && <SeekAiSectionDivider />}
        {shouldRenderGenerateAdSection && (
          <Stack space="medium">
            <Heading level="4">{t('seek-ai-heading')}</Heading>
            <Text size="small">{t('seek-ai-prompt')}</Text>
            <Inline space="none">
              <Button
                tone="brandAccent"
                variant="ghost"
                onClick={onGenerateDescription}
                size="small"
              >
                {t('seek-ai-generate-cta')}
              </Button>
            </Inline>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
